/** Native task approval stamps, derived Visit summaries and standing query contracts. */
import { Entity } from '../../entity';

/** Parent scope of the task Approvals board and its internal standing queries. */
export interface TaskApprovalScope {
    customerId: string;
    siteId?: string;
    servicePlanId?: string;
}

/** Manual authorisation of exactly one row revision, atomically replaced or cleared by its writer. */
export interface TaskApproval {
    approvedBy: Entity;
    approvedAt: Date;
    revision: number;
    operationId: string;
    note?: string;
    constructionClaim?: TaskApprovalConstructionClaim;
}

/** Job construction fences withdrawal with a claim on the approved row. */
export interface TaskApprovalConstructionClaim {
    jobId: string;
    at: Date;
}

/** Minimal shape consumed by the pure summary rule. */
export interface TaskApprovalSummaryRow {
    revision: number;
    approval?: Pick<TaskApproval, 'revision'> | null;
}

/** Indexed board projection; detail and construction read the native rows directly. */
export interface VisitTaskApprovalSummary {
    status: TaskApprovalStatus;
    total: number;
    approved: number;
    changed: number;
}

/** Manual row status, or the unstamped row's derived line policy. */
export enum TaskApprovalStatus {
    Approved = 'Approved',
    PartlyApproved = 'PartlyApproved',
    NotApproved = 'NotApproved',
    NeedsReview = 'NeedsReview',
    AutoApproved = 'AutoApproved',
}

/** Current status and attribution; approvalKey fences construction against later decisions. */
export interface TaskApprovalStanding {
    approvalStatus: TaskApprovalStatus;
    approvedBy?: Entity;
    approvedAt?: Date;
    approvedTasks?: number;
    approvalKey?: string;
}

/** Transport-safe statuses keyed by Visit identity. */
export interface TaskApprovalStandingPage {
    standings: Record<string, TaskApprovalStatus>;
}

/** Single-Visit authority read, scoped by its existing parent identity. */
export interface TaskApprovalCurrentRequest {
    occurrenceId: string;
    scope: TaskApprovalScope;
    serviceLineId?: string;
}
